import React, { useEffect, useState } from 'react'
import { countRecords, processRequests } from '../api/indexedDBHandler'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import '../styles/main.css'
const StatusRequestsBar = () => {
  const [recordCount, setRecordCount] = useState(0)
  useEffect(() => {
    const fetchRecordCount = async () => {
      try {
        const count = await countRecords('requests')
        setRecordCount(count)
        if (count > 0) {
          const process = await processRequests()
          console.log('Запросы обработаны:', process)
        }
      } catch (error) {
        console.error('Ошибка при подсчете записей:', error)
      }
    }

    const intervalId = setInterval(fetchRecordCount, 2000)
    return () => clearInterval(intervalId)
  }, [])
  return (
    <Container>
      <Typography
        className="color-text-gray"
        variant="caption"
        gutterBottom
        sx={{ display: 'block' }}
      >
        Очередь отправки данных: {recordCount}
      </Typography>
    </Container>
  )
}
export default StatusRequestsBar
